import { useState } from 'react';
import {
    FormControl,
    FormLabel,
    Text,
    Stack,
    Box,
    FormErrorMessage,
} from '@chakra-ui/react';
import { Field } from 'formik';
import { TextEditor } from '../../../../../components';
import TriggerFieldToolTip from './TriggerFieldToolTip';
import { useTriggerForm } from '../useTriggerForm.js';
import { FORM_FIELD_PATHS } from '../triggerFormConstants.js';
import walkthroughIds from '../../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

// Custom Formik field component for TextEditor
const TextEditorField = ({
    field,
    form,
    setCursorPosition,
    editMode,
    formData,
    updateFormData,
    ...props
}) => {
    const handleSubjectChange = (e) => {
        const newValue = e.target.value;

        // Update context with the new value
        updateFormData(FORM_FIELD_PATHS.SUBJECT, newValue);

        // Also update Formik field value for validation
        form.setFieldValue(field.name, newValue);
    };

    return (
        <TextEditor
            {...props}
            id="subject"
            field="subject"
            setCursorPosition={setCursorPosition}
            textfield={{
                label: '',
                value: formData?.action?.subject || '',
                multiline: false,
                onChange: handleSubjectChange,
                onBlur: () => {
                    form.setFieldTouched(field.name, true);
                },
            }}
            dataWalkthroughId={editMode.ufSubjectInput}
        />
    );
};

const SubjectInput = ({ darkMode, setCursorPosition, errors, touched }) => {
    const { editMode } = walkthroughIds;
    const [isHovered, setIsHovered] = useState(false);

    // Use context instead of Redux
    const { formData, updateFormData } = useTriggerForm();

    return (
        <FormControl
            sx={{ margin: '0 !important', position: 'relative' }}
            isInvalid={!!errors?.subject && touched?.subject}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel
                        htmlFor="subject"
                        sx={formLabelStyling(darkMode)}>
                        Subject
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enter the subject line for the email notification.
                    </Text>
                </Box>
                <Box flex={1} paddingTop="15px" maxWidth={400}>
                    <Field
                        component={TextEditorField}
                        name="subject"
                        darkMode={darkMode}
                        setCursorPosition={setCursorPosition}
                        editMode={editMode}
                        formData={formData}
                        updateFormData={updateFormData}
                        // validate={(value) => {
                        //     if (!value || value.trim().length === 0) {
                        //         return 'Subject is required';
                        //     }
                        //     if (value.length > 200) {
                        //         return 'Subject must be less than 200 characters';
                        //     }
                        // }}
                    />
                    {errors?.subject && touched?.subject && (
                        <FormErrorMessage>{errors.subject}</FormErrorMessage>
                    )}
                    <TriggerFieldToolTip
                        isVisible={isHovered}
                        label="Enter a clear and descriptive subject line for the email notification. Keep it concise and informative."
                        ariaLabel="subject-input-tip"
                    />
                </Box>
            </Stack>
        </FormControl>
    );
};

export default SubjectInput;
